/**
 * @packageDocumentation
 * @module f1/array
 */

import { t_bounds } from '../types';

export interface Bounds {
  /**
   * Generate the bounds for this array [0, n]
   *
   * @public
   * @function f1.bounds
   * @param arr the array to chunk
   * @example
   *
   * ```ts
   * f1.bounds([1, 2, 3, 4, 5]) => [0, 5]
   * f1.bounds([]) => [0, 0]
   * ```
   *
   */
  (arr: unknown[]): t_bounds;
}

/**
 * @see Bounds
 */
export default (arr: unknown[]): t_bounds => {
  return [0, arr.length];
};
